import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/stock-average-cost-calculator',
  component: () => import('../../routes/StockAverageCostCalculator.svelte'),
  card: {
    id: 'stock-average-cost-calculator',
    title: 'Stock Average Cost',
    description:
      'Calculate the average cost per share across multiple buy lots. See total cost basis, current market value, and unrealized gain or loss on your position.',
    icon: 'analytics',
    iconBgClass: 'bg-emerald-50',
    iconTextClass: 'text-emerald-600',
    href: '/stock-average-cost-calculator',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Stock Average Cost Calculator – Cost Basis Across Multiple Buys',
    description:
      'Free stock average cost calculator. Find your true cost per share across multiple buy lots, total cost basis, current market value, and unrealized gain or loss. Supports commissions and fractional shares.',
  },
};

export default meta;
